"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var model_1 = require("../../impl/model");
var MethodType;
(function (MethodType) {
    MethodType[MethodType["GET"] = 1] = "GET";
    MethodType[MethodType["POST"] = 2] = "POST";
    MethodType[MethodType["PUT"] = 3] = "PUT";
})(MethodType = exports.MethodType || (exports.MethodType = {}));
